import { mount } from "svelte";
import "./app.css";
import "./i18n";
import "./theme";
import App from "./App.svelte";
import { reloadStorageModel } from "../libs/storage-manager";
const app = mount(App, {
  target: document.getElementById("app")!,
});

export default app;
